export default {
    methods: {
        hirakana (str) {
            return str.replace(/[ァ-ヶ]/g, function (c) {
                return String.fromCharCode(c.charCodeAt(0) - 0x60)
            })
        },
        katakana (str) {
            return str.replace(/[ぁ-ん]/g, function (c) {
                return String.fromCharCode(c.charCodeAt(0) + 0x60)
            })
        },
        searchByKeyword(props, keyword) {
            var fields = [
                'title',
                'sub_title',
                'category',
                'tags',
                'description',
                'facilities',
                'custom_fields',
                'item'
            ];
            var keywords = keyword.split(/\s+/);
            return keywords.every((key) => {
                const pattern = new RegExp(`${key}`, 'i');
                const hirakanaPattern = new RegExp(`${this.hirakana(key)}`, 'i');
                const katakanaPattern = new RegExp(`${this.katakana(key)}`, 'i');
                return fields.some((field) => {
                    switch (field) {
                        case 'category':
                            return pattern.test(props.category.title) || hirakanaPattern.test(props.category.title) || katakanaPattern.test(props.category.title);
                        case 'tags':
                            return props.tags.some((tag) => pattern.test(tag) || hirakanaPattern.test(tag) || katakanaPattern.test(tag));
                        case 'facilities':
                            return props.facilities.some((facility) =>
                                pattern.test(facility.title) || hirakanaPattern.test(facility.title) || katakanaPattern.test(facility.title)
                            );
                        case 'custom_fields':
                            if (!props.custom_fields) return false;

                            return props.custom_fields.some(
                                (el) => pattern.test(el.title) || pattern.test(el.text) || hirakanaPattern.test(el.title) || katakanaPattern.test(el.title) || hirakanaPattern.test(el.text) || katakanaPattern.test(el.text)
                            );
                        case 'item':
                            return props.items.some((item) =>
                                pattern.test(item.title) || hirakanaPattern.test(item.title) || katakanaPattern.test(item.title)
                            );
                        default:
                            return pattern.test(props[`${field}`]) || hirakanaPattern.test(props[`${field}`]) || katakanaPattern.test(props[`${field}`]);
                    }
                });
            });
        }
    }
}